import React, { FC } from 'react'

type TableHeadProps = React.TableHTMLAttributes<HTMLTableSectionElement>

export const TableHead: FC<TableHeadProps> = ({ children, ...props }) => {
  return <thead {...props}>{children}</thead>
}

TableHead.displayName = 'TableHead'
